import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { CommandEffects, ConditionEffects, RuleEffects } from "./effects";
import { commandReducer, conditionReducer, ruleReducer } from "./reducers";

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature("chrule", ruleReducer),
        StoreModule.forFeature("chscenecommand", commandReducer),
        StoreModule.forFeature("chCondition", conditionReducer),
        EffectsModule.forFeature([RuleEffects]),
        EffectsModule.forFeature([CommandEffects]),
        EffectsModule.forFeature([ConditionEffects]),
    ],
    providers: [RuleEffects],
})
export class RuleStoreModule {}
